import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Button, Menu, Upload, Select, Space, notification, Dropdown} from 'antd';
import {Pages} from "../../../AppRouter";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useModal} from "../../../core/context/ModalContext";
import {UploadOutlined, DownOutlined} from '@ant-design/icons';
import FileUtils from "../../../core/utils/file-utils";
import ApiService from "../../../core/service/api-service";
import HospitalDoctors from "../HospitalDoctors";
import HospitalUserPermission from "../HospitalUserPermission";
import HospitalCreateEdit from "../HospitalCreateEdit";
import {useState} from "react";
import {useDataGrid} from '../../../core/components/data-grid/DataGridContext';
import {v4} from 'uuid';
import { TemplateLanguages } from "../../../enums/TemplateLanguages";

const ButtonGroup = Button.Group;  // v5: antd/lib/button/button-group derin yolu yerine resmî API

// Liste src/enums/TemplateLanguages.js dosyasina tasindi (builder ile ortak kullaniliyor).
// Mevcut import'lar bozulmasin diye buradan yeniden disa aktariliyor.
export const ReportTemplateLanguages = TemplateLanguages;

export default function HospitalRowMenu({row})
{
    const {t} = useTranslation();
    const history = useHistory();
    const {openModal, closeModal} = useModal();
    const { refreshDataGrid } = useDataGrid();
    
    return (
        <>
            <RowMenu text={row.id}>
                <Menu>
                    <Menu.Item key={'hospital-edit'} onClick={() => {
                        // history.push(Pages.Hospital.Edit(row.id))
                        openModal(t('Hospital Users Permission'), (
                            <>
                                <HospitalCreateEdit
                                    hospitalId={row.id}
                                />
                            </>
                        ))
                    }}>
                        <div>
                            {t('Edit')}
                        </div>
                    </Menu.Item>
                    <Menu.Item key={'hospital-user-edit'} onClick={() => {
                        openModal(t('Hospital Users Permission'), (
                            <>
                                <HospitalUserPermission
                                    hospitalId={row.id}
                                />
                            </>
                        ))
                    }}>
                        <div>
                            {t('Users')}
                        </div>
                    </Menu.Item>
                    <Menu.Item key={'hospital-doctor-edit'} onClick={() => {
                        openModal('Hospital Doctors', (
                            <>
                                <HospitalDoctors
                                    hospitalId={row.id}
                                    onSave={async (data) => {
                                        const res = await ApiService.UserManager.SetDoctorsToHospital(row.id, data.map(x => ({
                                            userId: x?.user?.id,
                                            // isDefault artık okunmuyor; mevcut değer korunuyor,
                                            // kolon ileride kalkacak. Dağıtımı weight belirliyor.
                                            isDefault: x?.isDefault ?? false,
                                            weight: x?.weight ?? 0
                                        })))

                                        if(res.success) {
                                            closeModal()
                                        }
                                    }}
                                />
                            </>
                        ))
                    }}>
                        <div>
                            {t('Doctors')}
                        </div>
                    </Menu.Item>
                    <Menu.Item
                        key={v4()}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Dropdown
                            overlay={
                                <Menu
                                    onClick={async ({ key }) => {
                                        const file = await FileUtils.getFileAsBase64({ accept: 'docx' });

                                        if (file) {
                                            const response = await ApiService.ReportOutputTemplate.UploadReportOutputTemplate(row.id, {
                                                docxFileBase64: file.data,
                                                language: key
                                            })
                                            if (response.success) {
                                                notification.success({
                                                    message: t('Template uploaded successfully.')
                                                });
                                                await refreshDataGrid();
                                            }
                                        }
                                    }}
                                >
                                    {
                                        ReportTemplateLanguages.map(code => (
                                            <Menu.Item key={code}>
                                                {row.reportOutputTemplates?.map(a => a.language)?.includes(code)
                                                    ? `${t(`lang_${code}`)} (Uploaded)`
                                                    : t(`lang_${code}`)}
                                            </Menu.Item>
                                        ))
                                    }
                                </Menu>
                            }
                            trigger={['click']}
                        >
                            <Button
                                size="small"
                                style={{ padding: '0 8px', width: 180 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {t('Upload Report Template')} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </Menu.Item>
                    <Menu.Item
                        key={v4()}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Dropdown
                            overlay={
                                <Menu
                                    onClick={async ({ key }) => {
                                        const template = row.reportOutputTemplates.find(x => x.language === key);
                                        if (!template) {
                                            notification.error({
                                                message: t('No template found for the selected language.')
                                            });
                                            return;
                                        }
                                        const response = await ApiService.ReportOutputTemplate.DownloadReportOutputTemplate(template.id, row.id, key)
                                        if (response.success) {
                                            ApiService.downloadFile(response.data, 'template.docx')
                                        }
                                    }}
                                >
                                    {
                                        ReportTemplateLanguages.map(code => (
                                            <Menu.Item key={code}>
                                                {row.reportOutputTemplates?.map(a => a.language)?.includes(code)
                                                    ? `${t(`lang_${code}`)} (Uploaded)`
                                                    : t(`lang_${code}`)}
                                            </Menu.Item>
                                        ))
                                    }
                                </Menu>
                            }
                            trigger={['click']}
                        >
                            <Button
                                size="small"
                                style={{ padding: '0 8px', width: 180 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {t('Download Template')} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </Menu.Item>
                </Menu>
            </RowMenu>
        </>
    )
}
